import React from "react"
import {useCustomRewardsQuery} from "@irati/custom-reward/hooks"
import Loading from "@irati/ui/src/Loading"
import CustomRewardItem from "./CustomRewardsListItem"

const CustomRewardsList = () => {
  const {data, loading} = useCustomRewardsQuery({}, {fetchPolicy: "cache-and-network"})
  return (
    <Loading isLoading={loading}>
      {data?.map((customReward) => (
        <CustomRewardItem key={customReward.uuid} customReward={customReward} />
      ))}
    </Loading>
  )
}

export default CustomRewardsList
